import { render, staticRenderFns } from "./changePswDialog.vue?vue&type=template&id=0aa2153e&scoped=true&"
import script from "./changePswDialog.vue?vue&type=script&lang=js&"
export * from "./changePswDialog.vue?vue&type=script&lang=js&"
import style0 from "./changePswDialog.vue?vue&type=style&index=0&id=0aa2153e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2153e",
  null
  
)

export default component.exports